import React from "react";
import { ModalProps } from "rsuite";
import cn from "classnames";

import CommonModal from "components/Common/Modal/Modal";

import "./Modal.less";

interface Props extends Omit<ModalProps, "size" | "backdrop" | "className"> {
    loading?: boolean;
    closeButton?: boolean;

    header?: React.ReactNode;
    footer: React.ReactNode;

    userMessage?: React.ReactNode;
    completeMessage?: React.ReactNode;
    steps?: React.ReactNode;
}

const Modal: React.FC<Props> = ({
    header,
    footer,
    userMessage,
    completeMessage,
    steps,
    open,
    loading,
    ...props
}: Props) => {
    return (
        <CommonModal
            isModalOpen={open ?? false}
            isModalLoaderVisible={loading ?? false}
            errorMessage=""
            backdrop="static"
            size={"md"}
            header={header}
            footer={footer}
            className={cn(
                "custom-modal__container",
                "workflow-modal__container"
            )}
            {...props}
        >
            {steps}
            {userMessage}
            {completeMessage}
        </CommonModal>
    );
};

export default Modal;
